import type { MapState } from '../state/mapState';

export type VisibilityRule =
  | 'always'
  | { predicate: (state: MapState) => boolean };

export function evaluateVisibility(rule: VisibilityRule, state: MapState): boolean {
  if (rule === 'always') return true;
  return rule.predicate(state);
}
